import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessProjectFormSubmitRoute: InvariantJiraRoute = {
	name: 'classic-business-form-submit',
	path: '/jira/core/projects/:projectKey/form/:formId',
	exact: true,
};
